import {Model} from './Model';

export class City extends Model {
  public title: string = '';
  public zip: number = 0;
  public stateId: number = 0;

  constructor(data: any) {
    super(data);

    this.title = data.title;
    this.zip = data.zip;
    this.stateId = data.stateId;
  }

  toString(): string {
    return this.title;
  }
}
